export default __webpack_public_path__ + "static/media/arrow_undo.77a21be2.svg";